class Navdrawer extends HTMLElement {
  constructor() {
    super();

    this.slideParent = this.querySelector(".navdrawer__slide");
    this.slideGroupParent = this.querySelector(".navdrawer__slide-group");
    this.slideNodeList = this.slideGroupParent.querySelectorAll(
      ".navdrawer__slideItem"
    );

    this.navDrawerMain = this.querySelector(".nav__drawer-main-list");
    this.navDrawerControlList =
      this.navDrawerMain.querySelectorAll("navdrawer-control");

    this.slidesById = {};
    this.slideNodeList.forEach((slide) => {
      this.slidesById[slide.id] = slide;
    });

    this.activeSlide;
  }

  // Closed, the panel is inert again and the menu under it live; focus that was in it goes back to the category it came
  // from (the back arrow).
  closeSlideDrawer() {
    const hadFocus = this.slideParent.contains(document.activeElement);
    this.slideParent.removeAttribute("open");
    this.slideParent.setAttribute("inert", "");
    this.querySelector("#navdrawer .nav__drawer")?.removeAttribute("inert");
    if (hadFocus && this.slideOpener && this.slideOpener.isConnected) this.slideOpener.focus({ preventScroll: true });
    this.slideOpener = null;
  }

  // The sub-level panel sits beside the drawer, not in it: it closes with the menu (a click outside, Esc, the close
  // button), or it stayed on screen over the page (owner, 2026-10-28).
  closeSlideWithDrawer() {
    const drawer = this.querySelector("dra-wer#navdrawer");
    if (!drawer) return;
    new MutationObserver(() => {
      if (!drawer.hasAttribute("open") && this.slideParent.hasAttribute("open")) this.closeSlideDrawer();
    }).observe(drawer, { attributes: true, attributeFilter: ["open"] });
  }

  listenForCloseDrawer() {
    this.closeControlList = this.querySelectorAll(".navdrawer__slide-back");

    this.closeControlList.forEach((elem) => {
      elem.addEventListener("click", this.closeSlideDrawer.bind(this));
    });
  }

  hideActiveSlide() {
    this.activeSlide.removeAttribute("open");
  }

  refreshSlide(activeSlide) {
    // Controls that only link (no slide rendered for them) have nothing to open.
    if (!this.slidesById[activeSlide]) return;

    if (this.activeSlide) {
      this.hideActiveSlide();
    }

    this.activeSlide = this.slidesById[activeSlide];
    this.activeSlide.setAttribute("open", "");
    // The open category's name in the head bar.
    const title = this.querySelector("[data-slide-title]");
    if (title) {
      const text = title.querySelector("[data-slide-title-text]") || title;
      text.textContent = this.activeSlide.dataset.title || "";
      // The name links to the whole category where it has a page (snippets/navdrawer-slide-body.liquid).
      const all = this.activeSlide.querySelector("[data-slide-all-href]");
      if (all) title.setAttribute("href", all.dataset.slideAllHref);
      else title.removeAttribute("href");
    }
    this.slideParent.removeAttribute("inert");
    this.slideParent.setAttribute("open", "");
    // The menu under the panel (same width, below it) is out of reach meanwhile, so Tab stays in what is on screen.
    this.querySelector("#navdrawer .nav__drawer")?.setAttribute("inert", "");
    // Focus follows into the panel (its back arrow), so the keyboard is where the eye is.
    const from = document.activeElement;
    if (from && this.contains(from) && !this.slideParent.contains(from)) this.slideOpener = from;
    const back = this.slideParent.querySelector(".navdrawer__slide-back-btn");
    if (back) requestAnimationFrame(() => back.focus({ preventScroll: true }));
  }

  connectedCallback() {
    this.listenForCloseDrawer();
    this.closeSlideWithDrawer();

    setTimeout(() => {
      this.classList.remove("preinit");
    }, 400);
  }
}

class NavdrawerControl extends HTMLElement {
  constructor() {
    super();
    this.navdrawer = document.querySelector("nav-drawer");
  }

  onInteraction(event) {
    if (event && this.hasAttribute("data-ignore-link")) {
      event.preventDefault();
    }

    this.navdrawer.refreshSlide(this.getAttribute("for"));
  }

  listenForInteraction(e) {
    this.addEventListener("click", this.onInteraction.bind(this));
  }

  connectedCallback() {
    this.listenForInteraction();
  }
}

customElements.define("nav-drawer", Navdrawer);
customElements.define("nav-drawer-control", NavdrawerControl);
